import type { CSSProperties } from 'react'
import type { ModalProps } from 'antd'
import { Modal, Typography } from 'antd'
import './AppFormModal.css'

type AppFormModalProps = ModalProps & {
  /** 标题下方一行灰色说明（可选，尽量简短） */
  hint?: string
  /** 内容区固定高度（px），不出现滚动条 */
  bodyHeight?: number
  /** 紧凑表单间距 */
  compact?: boolean
}

const DEFAULT_WIDTH = 560
const DEFAULT_BODY_HEIGHT = 360

type AppFormModalStyle = CSSProperties & {
  '--app-form-modal-body-height': string
}

/** 后台 CRUD / 设置类表单弹窗：固定宽高、无滚动条、取消/保存文案统一。 */
export function AppFormModal({
  hint,
  width = DEFAULT_WIDTH,
  bodyHeight = DEFAULT_BODY_HEIGHT,
  compact = true,
  cancelText = '取消',
  destroyOnHidden = true,
  className,
  styles,
  style,
  children,
  ...rest
}: AppFormModalProps) {
  return (
    <Modal
      width={width}
      cancelText={cancelText}
      destroyOnHidden={destroyOnHidden}
      className={['app-form-modal', compact ? 'app-form-modal--compact' : '', className]
        .filter(Boolean)
        .join(' ')}
      styles={styles}
      style={
        {
          ...style,
          '--app-form-modal-body-height': `${bodyHeight}px`,
        } as AppFormModalStyle
      }
      {...rest}
    >
      {hint ? (
        <Typography.Text type="secondary" className="app-form-modal__hint">
          {hint}
        </Typography.Text>
      ) : null}
      {children}
    </Modal>
  )
}
